/**
 * Read-only and editable view for guided session notes (BHS + Prescriber).
 * @version 2
 */
import type { Note } from "@/core/types";
import { ProviderEnum } from "@/core/constants";

import { BehavioralNewNote } from "./BehavioralNewNote";
import { PrescribeNewNote } from "./PrescribeNewNote";

type Props = {
  editable?: boolean;
  editHandler?: (...args: unknown[]) => void;
  errors?: Record<string, unknown>;
  isCallManuallyLinked?: boolean;
  note: Note;
  patientAnswersEditable?: boolean;
  profile?: Record<string, unknown>;
  views?: Record<string, boolean>;
};

export function GuidedSessionView({
  editable = false,
  editHandler,
  errors = {},
  isCallManuallyLinked = false,
  note,
  patientAnswersEditable,
  profile = {},
  views = {},
}: Props) {
  const sharedProps = {
    editable,
    editHandler,
    errors,
    isCallManuallyLinked,
    note,
    patientAnswersEditable,
    profile,
    views,
  };

  if (note.provider_type.startsWith(ProviderEnum.BEHAVIORAL))
    return <BehavioralNewNote {...sharedProps} />;
  if (note.provider_type.startsWith(ProviderEnum.PRESCRIBE))
    return <PrescribeNewNote {...sharedProps} />;

  return null;
}
